import SsoB3Route from "../../UrlRoute/SsoB3Route";
import axios from "axios";

export const USERS_LOGIN = "USERS_LOGIN";
export const USERS_OTP = "USERS_OTP";
export const USERS_ORGANIZATION = "USERS_ORGANIZATION";
export const ALL_ORGANIZATION_USERS = "ALL_ORGANIZATION_USERS";
export const VERIFY_SESSION = "VERIFY_SESSION";
export const LOGOUT_SESSION = "LOGOUT_SESSION";

// ==================================== Users Profile ======================================//
export const UsersLogin = (data) => {
  return async (dispatch) => {
    return await SsoB3Route.Login(data)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: USERS_LOGIN,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: USERS_LOGIN,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .then((dada) => {
        // console.log(dada, "HASDASDASDAS");
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: USERS_LOGIN,
            payload: {
              data: error.response.data,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: USERS_LOGIN,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Users Profile ======================================//

// ==================================== Users OTP ======================================//
export const UsersOtp = (data) => {
  return async (dispatch) => {
    return await SsoB3Route.Otp(data)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: USERS_OTP,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: USERS_OTP,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: USERS_OTP,
            payload: {
              data: error.response.data,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: USERS_OTP,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Users OTP ======================================//

// ==================================== Start Users Organization ======================================//
export const UsersOrg = (userId, param) => {
  return async (dispatch) => {
    return await SsoB3Route.Organization(userId, param)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: USERS_ORGANIZATION,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: USERS_ORGANIZATION,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: USERS_ORGANIZATION,
            payload: {
              data: error.response.data,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: USERS_ORGANIZATION,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Users Organization ======================================//

// ==================================== Start Organization Users ======================================//
export const AllOrganizationUsers = (orgUuid, param) => {
  return async (dispatch) => {
    return await SsoB3Route.OrganizationUsers(orgUuid, param)
      .then((response) => {
        if (response.data.length === 0) {
          dispatch({
            type: ALL_ORGANIZATION_USERS,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: ALL_ORGANIZATION_USERS,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: ALL_ORGANIZATION_USERS,
            payload: {
              data: error.response.data,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: ALL_ORGANIZATION_USERS,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Organization Users ======================================//
// ==================================== Start Organization Users ======================================//
export const TestVerify = () => {
  return async (dispatch) => {
    return await SsoB3Route.VerifySession()
      .then((response) => {
        // console.log(response, "INILAH RESPONSENYA !@!@!");
        if (response.success === false) {
          dispatch({
            type: VERIFY_SESSION,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          // console.log(response, "INI RESPONSENYA ");
          dispatch({
            type: VERIFY_SESSION,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: VERIFY_SESSION,
            payload: {
              data: error.response.data,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: VERIFY_SESSION,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Organization Users ======================================//
// ==================================== Start Organization Users ======================================//
export const Logout = () => {
  return async (dispatch) => {
    return await SsoB3Route.Logout()
      .then((response) => {
        // console.log(response, "RESPONSE LOGOUT SESSION");
        if (response.success === false) {
          dispatch({
            type: LOGOUT_SESSION,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: LOGOUT_SESSION,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: LOGOUT_SESSION,
            payload: {
              data: error.response.data,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: LOGOUT_SESSION,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Organization Users ======================================//

// ==================================== Start Session Token Verify ======================================//
export const VerifySessionToken = () => {
  return async (dispatch) => {
    return await axios
      .head(
        "https://api.b3works.com/prod/api/v1/b3/_a/auth/private/v2/sessiontokens",
        {
          headers: {
            Cookie: `sessionToken=${localStorage.getItem("sessionToken")}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 401) {
          dispatch({
            type: VERIFY_SESSION,
            payload: {
              data: false,
              errorMessage: "Data Not Found",
            },
          });
        } else {
          dispatch({
            type: VERIFY_SESSION,
            payload: {
              data: response,
              errorMessage: false,
            },
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          dispatch({
            type: VERIFY_SESSION,
            payload: {
              data: error.response.data,
              errorMessage: error.response.data.message,
            },
          });
        } else {
          dispatch({
            type: VERIFY_SESSION,
            payload: {
              data: false,
              errorMessage: error.message,
            },
          });
        }
      });
  };
};
// ==================================== End Organization Users ======================================//
